export default "__VITE_PUBLIC_ASSET__18044844__"